import * as React from 'react'

function SvgTiresChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path d="M20 11c0-.687.077-1.355.223-1.998A11.205 11.205 0 0 0 20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11c0-.074 0-.148-.002-.223a9.032 9.032 0 0 1-2.773.19c-.144.175-.23.397-.247.63-.035.47-.11.93-.223 1.375-.057.226.193.426.393.305l.654-.392a8.932 8.932 0 0 1-.743 2.125l-.584.01c-.35.006-.666.197-.863.485-.263.386-.56.747-.885 1.08-.163.168-.046.465.188.462l.763-.013a9.054 9.054 0 0 1-1.704 1.468l-.51-.282a1.078 1.078 0 0 0-.991-.011c-.415.2-.85.366-1.302.493-.226.063-.273.38-.069.494l.667.37a8.964 8.964 0 0 1-2.213.417l-.3-.5c-.18-.3-.504-.48-.853-.505-.47-.035-.93-.11-1.374-.223-.227-.057-.426.193-.306.394l.392.653a8.932 8.932 0 0 1-2.125-.742l-.01-.584a1.078 1.078 0 0 0-.485-.864 8.038 8.038 0 0 1-1.08-.884c-.168-.164-.465-.047-.461.187l.012.763a9.05 9.05 0 0 1-1.468-1.704l.282-.509c.17-.306.164-.676.011-.992-.2-.415-.366-.85-.493-1.302-.063-.225-.38-.273-.493-.068l-.37.667a8.966 8.966 0 0 1-.418-2.214l.5-.3c.3-.18.48-.504.505-.852.035-.471.11-.93.223-1.375.057-.227-.193-.426-.394-.306l-.653.393c.159-.747.41-1.46.742-2.126l.584-.01c.35-.005.667-.196.864-.485.263-.385.56-.747.884-1.08.163-.167.046-.465-.187-.461l-.763.013a9.044 9.044 0 0 1 1.704-1.469l.508.283c.307.17.677.162.993.01.415-.2.85-.366 1.302-.493.225-.063.273-.38.068-.493l-.667-.37a8.966 8.966 0 0 1 2.214-.418l.3.5c.076.126.176.23.294.311A9.107 9.107 0 0 1 20 11Z" />
      <path d="M20 14c.175 0 .349.008.52.022a8.98 8.98 0 0 0 1.312 2.421 4 4 0 1 0 1.725 1.725 8.98 8.98 0 0 0 2.42 1.312A6 6 0 1 1 20 14Z" />
    </svg>
  )
}

export default SvgTiresChecked
